export { default } from "./ErrorPage"
